import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod/v4";
import { TaxAdvisoryCompanies } from "../../../../companies/TaxAdvisoryCompanies";

const searchSchema = z.object({
  search: z.string().optional().default(""),
});

export const Route = createFileRoute("/beratung/$taxAdvisoryId/unternehmen/")({
  validateSearch: zodValidator(searchSchema),
  component: UnternehmenRoute,
});

function UnternehmenRoute() {
  const navigate = useNavigate();
  const { taxAdvisoryId } = Route.useParams();
  const search = Route.useSearch({ select: ({ search }) => search });

  const setSearch = (newSearch: string) => {
    navigate({
      to: "/beratung/$taxAdvisoryId/unternehmen",
      params: { taxAdvisoryId },
      search: { search: newSearch },
    });
  };

  return (
    <TaxAdvisoryCompanies
      taxAdvisoryId={taxAdvisoryId}
      search={search}
      setSearch={setSearch}
    />
  );
}
